/**
 * jQuery Select plugin
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

'use strict'; // eslint-disable-line

/**
 * @type {jQuery|exports|module.exports|Function}
 */

var jQuery = require('jquery');

/**
 * @type {Container|exports|module.exports|Function}
 */
var Container = require('./container');

var pluginName = 'rpSelect';

jQuery.fn[pluginName] = function (options) {
    var settings = jQuery.extend({
        wrapper: '<div></div>',
        position: {
            my: 'center top',
            at: 'center bottom+8'
        }
    }, options);

    this.each(function () {
        var object = jQuery.data(this, pluginName);
        if (!object) {
            jQuery.data(this, pluginName, new Container(this, settings));
        }
    });

    return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-jquery-select/lib/select.js
// module id = 699
// module chunks = 1